/* Native Shopify forms remain usable without JavaScript. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function selectTab(group, tab, focus = false) {
    group.querySelectorAll('[role="tab"]').forEach(button => {
      const active = button === tab;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
    if (focus) tab.focus();
  }
  function selectMedia(gallery, link) {
    gallery.querySelectorAll('.product-media').forEach(media => {
      media.hidden = media.id !== link.dataset.mediaTarget;
      if (media.hidden) media.querySelectorAll('video').forEach(video => video.pause());
    });
    gallery.querySelectorAll('[data-media-target]').forEach(thumb => thumb.setAttribute('aria-current', String(thumb === link)));
  }
  function initialize(root) {
    root.querySelectorAll('[data-tabs]:not([data-ready])').forEach(group => {
      const first = group.querySelector('[role="tab"]');
      if (first) selectTab(group, first);
      group.dataset.ready = 'true';
    });
    root.querySelectorAll('[data-gallery]:not([data-ready])').forEach(gallery => {
      const first = gallery.querySelector('[data-media-target]');
      if (first) selectMedia(gallery, first);
      gallery.dataset.ready = 'true';
    });
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[role="tab"]');
    if (tab) selectTab(tab.closest('[data-tabs]'), tab);
    const thumb = event.target.closest('[data-media-target]');
    if (thumb) { event.preventDefault(); selectMedia(thumb.closest('[data-gallery]'), thumb); }
    const arrow = event.target.closest('[data-range-prev], [data-range-next]');
    if (arrow) {
      const track = arrow.closest('.range-section').querySelector('[data-range]');
      const card = track.querySelector('.card-wrapper');
      const direction = arrow.hasAttribute('data-range-prev') ? -1 : 1;
      track.scrollBy({left: direction * ((card ? card.getBoundingClientRect().width : track.clientWidth) + 18), behavior: reducedMotion.matches ? 'instant' : 'smooth'});
    }
    document.querySelectorAll('.mobile-nav[open], .nav-dropdown[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[role="tab"]');
    if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      const group = tab.closest('[data-tabs]');
      const tabs = [...group.querySelectorAll('[role="tab"]')];
      let index = tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      selectTab(group, tabs[index], true);
    }
    if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open], .nav-dropdown[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const option = event.target.selectedOptions[0];
    const group = event.target.closest('[data-product-form]');
    const price = group.querySelector('[data-variant-price]');
    price.textContent = option.dataset.price;
    if (option.dataset.compare) {
      const compare = document.createElement('s');
      compare.textContent = option.dataset.compare;
      price.append(' ', compare);
    }
    const quantity = group.querySelector('[data-quantity]');
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max;
    else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    const button = group.querySelector('[data-add-button]');
    const enabled = button.dataset.purchasing === 'true' && button.dataset.requiresPlan !== 'true';
    const available = option.dataset.available === 'true';
    button.disabled = !enabled || !available;
    button.querySelector('[data-add-label]').textContent = button.dataset.requiresPlan === 'true' ? 'Subscription setup required' : !enabled ? 'Coming soon' : available ? 'Add to bag' : 'Sold out';
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[role="tabpanel"]');
    if (panel) {
      const tab = document.getElementById(panel.getAttribute('aria-labelledby'));
      if (tab) selectTab(panel.closest('[data-tabs]'), tab);
    }
  });
  initialize(document);
  let shoppingObserver;
  function observeShopping() {
    if (shoppingObserver) shoppingObserver.disconnect();
    const bar = document.querySelector('[data-mobile-shop-bar]');
    const hero = document.querySelector('.campaign-hero');
    const shop = document.getElementById('shop');
    const choose = document.getElementById('choose');
    if (!bar) return;
    bar.hidden = true;
    if (!hero || !shop || !choose || !('IntersectionObserver' in window)) return;
    let passed = false;
    const shopping = new Set();
    shoppingObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        else if (entry.isIntersecting) shopping.add(entry.target);
        else shopping.delete(entry.target);
      });
      bar.hidden = !(passed && shopping.size === 0);
    });
    [hero, shop, choose].forEach(element => shoppingObserver.observe(element));
  }
  observeShopping();
  document.addEventListener('shopify:section:load', observeShopping);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(observeShopping));
})();
